module.exports = __webpack_public_path__ + "img/2025-05-09b_2.5b56d535.jpg";